/**GET REFERRAL LIST */
export interface Referral {
    id: string;
    member_ref: string;
    fname: string;
    lname: string;
    senior_center_id: string;
    org_id: string;
    org_name: string;
    need: string;
    need_id: number;
    department: string;
    department_id: number;
    created_by: string;
    created_on: string;
    updated_on: string;
    status: string;
}

export interface ReferralServiceProvider {
    id: number;
    zipcode: string;
    provider_name: string;
    organization: string;
    need: string;
    integration_type?: string;
    contact_detail?: {
          fname: string;
          lname: string;
          email: string;
          phone_no: string;
          job_title: string;
        }[];
}
export interface ReferralNameID {
    id: number;
    name: string;
    dept_name?: string;
}

/* REFERRAL REQUEST */
export interface ReferralRequest {
    member_ref: string;
    need_id: number;
    ref_notes: string;
    dept_id?: number;
    fname?: string;
    lname?: string;
    email?: string;
    phone_no?: string;
    job_title?: string;
    con_data_share?: boolean;
    con_email_send?: boolean;
    con_by?: string;
    org_id?: number | null;
    //zip?: string;
}

export interface ReferralStatusRequest {
  status: string;
  notes: string;  
  viewAsIncomingReferral?: string;
  orgId?: string;
}

export interface ReferralUpdateRequest {
  dept_id?: number;
  con_data_share?: boolean;
  con_by?: string;
  con_email_send?: boolean;
}

export interface ReferralDetails{
    id: string;
    status: string;
    ref_notes: string;
    dept_id: number;
    service_providers: ReferralServiceProvider[];
    need: {
      id: number;
      name: string;
      category: ReferralNameID;
    };
    user: {
      id: number;
      member_ref: string;
      fname: string;
      lname: string;
      phone_no: string;
      lang: string;
      organisation?: {
        name?: string;
      }
      ClientCenters: {
        id: number;
        SeniorCenter: {
          name: string;
        }
      }[];
      org_id: number;
      Programs: {id: number[]; name: string;};
    };
    contact: {
      fname: string;
      lname: string;
      email: string;
      phone_no: string;
      job_title: string;
      //zip: string;
    };
    referringOrg: {
      org_id: number;
      org_name: string; 
      org_logo: string;
    };
    created_on: string;
    updated_on: string;
    organisation?: { name: string; };
    con_data_share?: boolean;
    con_email_send?: boolean;
  }

export interface RegisterNeedResponse {
  ref_id: string;
}

export class referralReqProgress {
  onPage:boolean;
  onSave:boolean;
  onSubmit:boolean;
  onUpdate:boolean;
  onProviderUpdate:boolean;
  onOthers?:boolean;

  constructor(
    data?: {
      onPage?:boolean;
      onSave?:boolean;
      onSubmit?:boolean;
      onUpdate?:boolean;
      onProviderUpdate?:boolean;
      onOthers?:boolean;
    }
  ) {
    this.onPage = data?.onPage || false;
    this.onSave = data?.onSave || false;
    this.onSubmit = data?.onSubmit || false;
    this.onUpdate = data?.onUpdate || false;
    this.onProviderUpdate = data?.onProviderUpdate || false;
    this.onOthers = data?.onOthers || false;
  }
}
export type ReferralPageViewType = 'register' | 'create' | 'preSubmission' | 'detail';
export interface ReferralStatusData {
  all: string[];
  create: string[];
  detail: string[];
  preSubmission: string[];
}


//REFERRAL EMAIL AUTH
export type ReferralViewType = 'WELCOME' | 'NEEDS_CONFIRM' | 'FEEDBACK' | 'PERSON_CONFIRM' | 'VERIFY_PERSON' | 'END';

export interface ReferralCodeValidatePayload {
  email: string;
  code: string;
}
export class ReferralConfirmPayload {
  contactId: number;
  feedback?: string;
  departmentNeedsAddressed: boolean = false;
  newContactPerson?: {
    fname: string;
    lname: string;
    email: string;
    org_name: string;
    phone_no: string;
  }

  constructor(data: ReferralCodeValidateResponse) {
    this.contactId = data.contact.id;
    this.newContactPerson = {
      fname: data.contact.fname, 
      lname: data.contact.lname, 
      email: data.contact.email, 
      org_name: data.contact.org_name, 
      phone_no: ''
    }
  }
}
export interface ReferralCodeValidateResponse {
  message: string;
  contact: {
    id: number;
    fname: string;
    lname: string;
    email: string;
    org_name: string;
    dept_needs: {
      category: string;
      needs: { need: string; }[];
    }[];
  }
}